import api from '@/plugins/axios'

export const getAll = async () => {
  const response = await api.get('/rubro')
  return response.data
}

export const getById = async (id) => {
  const response = await api.get(`/rubro/${id}`)
  return response.data
}

export const create = async (data) => {
  const response = await api.post('/rubro', data)
  return response.data
}

export const update = async (id, data) => {
  const response = await api.put(`/rubro/${id}`, data)
  return response.data
}

export const remove = async (id) => {
  await api.delete(`/rubro/${id}`)
}
